import { ChevronsLeft, ChevronsRight } from "lucide-react"

interface ScrollEffectProps {
  showScrollEffectPosition: {
    left: boolean
    right: boolean
  }
  containerId: string
}

const ScrollEffect = ({
  showScrollEffectPosition,
  containerId,
}: ScrollEffectProps) => {
  return (
    <>
      {showScrollEffectPosition.left && (
        <button
          onClick={() => {
            const container = document.getElementById(containerId)
            if (container) {
              container.scrollTo({
                left: 0,
                behavior: "smooth",
              })
            }
          }}
          className={`absolute top-0 left-0 w-[100px] h-full flex items-center justify-center`}
          style={{
            background:
              "linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8))",
          }}
        >
          <ChevronsLeft className="w-20 h-20 animate-bounce-left" />
        </button>
      )}
      {showScrollEffectPosition.right && (
        <button
          onClick={() => {
            const container = document.getElementById(containerId)
            if (container) {
              container.scrollTo({
                left: container.scrollWidth,
                behavior: "smooth",
              })
            }
          }}
          className={`absolute top-0 right-0 w-[100px] h-full flex items-center justify-center`}
          style={{
            background:
              "linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8))",
          }}
        >
          <ChevronsRight className="w-20 h-20 animate-bounce-right" />
        </button>
      )}
    </>
  )
}

export default ScrollEffect
